<template>
  <div class="v-atlas-simplegeodata-main">
    <TabsGroup class="x-auto-expand">
      <Tab :label="`Objekte (${featuresTableData?.features?.length})`" tab-key="list"
        class="v-atlas-simplegeodata-main__features-list">
        <button v-for="feature in featuresTableData?.features" :key="feature.id" class="v-atlas-feature-list__item"
          @mouseover="onFeatureMouseOver(feature)" @click="onFeatureClick(feature)">
          {{ feature.properties?.name }}
        </button>
      </Tab>

      <Tab label="Optionen &amp; Filter" tab-key="options" class="v-atlas-simplegeodata-main__settings">
        <h3>Objektliste filtern</h3>
        <div>
          <SmartTextInput v-model="filterString" placeholder="Name ..." />
        </div>

        <div>
          <label style="display:flex;gap:8px;">
            <div>
              <input v-model="onlyFeaturesInMapExtent" type="checkbox"></input>
            </div>
            <div> Nur Objekte im aktuellen
              Kartenausschnitt
            </div>
          </label>
        </div>

        <div style="margin-top:20px;">
          <strong>{{ featuresTableData?.features?.length }} Ergebnisse</strong>
        </div>

        <h3>Daten herunterladen</h3>




        <a class="c-button" :href="downloadExcelUrl" download="data.xlsx"
          data-tooltip="Datensatz im Excel-365-Format (.xlsx) herunterladen">
          Excel
        </a>
        <a class="c-button" :href="downloadGeoJsonUrl" download="data.geojson"
          data-tooltip="Datensatz im GeoJSON-Format herunterladen">
          GeoJSON
        </a>
      </Tab>
    </TabsGroup>
    <LoadingIndicatorOverlay v-if="isLoadingDelayed" />
  </div>
</template>

<script setup lang="ts">
import { LoadingIndicatorOverlay, SmartTextInput, List, ViewStackController, useSmartFetch, useDelayedBoolean, Tab, TabsGroup, MapState } from 'gertrud';
import { computed, inject, ref, Ref } from 'vue';
import { SimpleGeodataMapModule } from './SimpleGeodataMapModule';




const props = withDefaults(defineProps<{
  mapModule: SimpleGeodataMapModule
  viewStackController: ViewStackController
}>(), {
})


const mapState: Ref<MapState> = inject("mapStateOut") as Ref<MapState>

const filterString = ref("")
const onlyFeaturesInMapExtent = ref(false)



function onFeatureClick(item: any) {


  const event = {
    feature: item
  }
  props.mapModule.onFeatureClick(event)


}

function onFeatureMouseOver(item: any) {

  const event = {
    feature: item
  }
  props.mapModule.onFeatureIn(event)
}



const featuresTableDataUrl = computed(() => {



  const s: any = {

    // Note: The features table does not require geometry data, so we can request the features without geometries:
    geometryType: "none",
    filterString: filterString.value,
    orderBy: "name",
  }


  if (onlyFeaturesInMapExtent.value) {
    s.extent = mapState.value.extent
  }



  const result = `${props.mapModule.moduleConfig.serviceBaseUrl}/data.geojson?settings=${encodeURIComponent(JSON.stringify(s))}`


  return result
})



const { data: featuresTableData, isLoading } = useSmartFetch<any>(featuresTableDataUrl)


const isLoadingDelayed = useDelayedBoolean(isLoading, 250, 0);


//#region Computed dataset download link URLs
const downloadGeoJsonUrl = computed(() => {


  const s: any = {
    filterString: filterString.value,
    orderBy: "name",
  }


  return `${props.mapModule.moduleConfig.serviceBaseUrl}/data.geojson?settings=${encodeURIComponent(JSON.stringify(s)
  )}`;
});


const downloadExcelUrl = computed(() => {


  const s: any = {
    filterString: filterString.value,
    orderBy: "name",
  }

  return `${props.mapModule.moduleConfig.serviceBaseUrl}/data.xlsx?settings=${encodeURIComponent(JSON.stringify(s))}`;
});

//#endregion Computed dataset download link URLs



</script>
